import React, { useState } from 'react';
import { Box, Button, Paper, Typography } from '@material-ui/core';
import { useDispatch } from 'react-redux';

function Forum({ classes, setNewPaymentMethod, setForum }) {
  const dispatch = useDispatch();
  const [sendCode, setSendCode] = useState(true);
  const [code, setCode] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();

    if(e == 'cancel')
      setNewPaymentMethod(false);
    else
    {
      setForum(false);
    }
  };

  return (
              <Paper className={classes.paper} elevation={0}>
                  <form onSubmit={handleSubmit}>
                      <Typography component="h1" variant="h5" className={classes.twoFactorHeader}>
                          {'Account Reactivation'}
                      </Typography>
                      <p>
                        { 'Please check email for reactivation link'}
                      </p>
                      <Button fullWidth className={classes.submitButton} type="submit">
                        {'Send'}
                      </Button>
                  </form>
              </Paper>
  );
}

export default Forum;
